// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SyncCalendar_yearDay__6fOU\\+,
.SyncCalendar_monthDay__mFDve {
  background: #ff00aa;
}

.SyncCalendar_day_processed__B3iDQ {
  background: var(--accent-color);
}

.SyncCalendar_day_processing__z5y\\+7 {
  background: #3b7fd4;
}

.SyncCalendar_day_pending__NYqPX {
  background: #00bcd4;
}

.SyncCalendar_day_waiting_archive__-KRGa {
  background: #64b5f6;
}

.SyncCalendar_day_duplicate__7sHQS {
  background: #8e6acb;
}

.SyncCalendar_day_upload_failed__644Bu {
  background: #efa12c;
}

.SyncCalendar_day_failed__M2BtJ {
  background: #df6767;
}

.SyncCalendar_day_no_data__DPw0l {
  background: #7a7a7a;
}

.SyncCalendar_day_empty__v6zMF {
  background: #dbdbdb;
}

.SyncCalendar_yearGrid__YM8hL {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-top: 10px;
}
@media (max-width: 900px) {
  .SyncCalendar_yearGrid__YM8hL {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 600px) {
  .SyncCalendar_yearGrid__YM8hL {
    grid-template-columns: repeat(2, 1fr);
  }
}

.SyncCalendar_yearMonth__TN8pm {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.SyncCalendar_yearMonthLabel__kgx1p {
  font-size: 11px;
  font-weight: 600;
  color: #838383;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.SyncCalendar_yearDayGrid__0Os87 {
  display: grid;
  grid-template-columns: repeat(7, 10px);
  gap: 2px;
}

.SyncCalendar_yearDay__6fOU\\+,
.SyncCalendar_yearEmptyCell__oVeXA {
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  border: none;
  padding: 0;
  cursor: pointer;
  position: relative;
}
.SyncCalendar_yearDay__6fOU\\+:hover,
.SyncCalendar_yearEmptyCell__oVeXA:hover {
  opacity: 0.75;
}

.SyncCalendar_yearDay__6fOU\\+:hover::after {
  content: attr(data-tip);
  position: absolute;
  bottom: calc(100% + 4px);
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.85);
  color: #fff;
  padding: 1px 6px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.3;
  white-space: nowrap;
  pointer-events: none;
  z-index: 10;
}

.SyncCalendar_yearEmptyCell__oVeXA {
  cursor: default;
  background: transparent;
}

.SyncCalendar_monthGrid__OTVBC {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
  margin-top: 10px;
  max-width: 560px;
}

.SyncCalendar_monthWeekday__DYSFO {
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  color: #838383;
  padding: 4px 0;
}

.SyncCalendar_monthDay__mFDve,
.SyncCalendar_monthEmptyCell__fmApu {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 500;
  color: #fff;
  border: none;
  cursor: pointer;
}
.SyncCalendar_monthDay__mFDve:hover,
.SyncCalendar_monthEmptyCell__fmApu:hover {
  opacity: 0.8;
}

.SyncCalendar_monthEmptyCell__fmApu {
  cursor: default;
  background: transparent;
  color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/dashboard/components/SyncMonitor/SyncCalendar/SyncCalendar.module.scss","webpack://./src/_common/scss/_colors.scss","webpack://./src/_common/scss/_variables.scss"],"names":[],"mappings":"AAOA;;EAEE,mBAAA;AANF;;AASA;EAAwB,+BCVf;ADKT;;AAMA;EAAwB,mBAAA;AAFxB;;AAGA;EAAwB,mBAAA;AACxB;;AAAA;EAAwB,mBAAA;AAIxB;;AAHA;EAAwB,mBAAA;AAOxB;;AANA;EAAwB,mBAAA;AAUxB;;AATA;EAAwB,mBCLhB;ADkBR;;AAZA;EAAwB,mBAAA;AAgBxB;;AAfA;EAAwB,mBCbb;ADgCX;;AAfA;EACE,aAAA;EACA,qCAAA;EACA,SEhBS;EFiBT,gBElBS;AFoCX;AAhBE;EANF;IAOI,qCAAA;EAmBF;AACF;AAjBE;EAVF;IAWI,qCAAA;EAoBF;AACF;;AAjBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAoBF;;AAjBA;EACE,eAAA;EACA,gBAAA;EACA,cCvCS;EDwCT,yBAAA;EACA,sBAAA;AAoBF;;AAjBA;EACE,aAAA;EACA,sCAAA;EACA,QAAA;AAoBF;;AAjBA;;EAEE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;AAoBF;AAlBE;;EACE,aAAA;AAqBJ;;AAjBA;EACE,uBAAA;EACA,kBAAA;EACA,wBAAA;EACA,SAAA;EACA,2BAAA;EACA,+BAAA;EACA,WCpEM;EDqEN,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,WAAA;AAoBF;;AAjBA;EACE,eAAA;EACA,uBAAA;AAoBF;;AAfA;EACE,aAAA;EACA,qCAAA;EACA,QAAA;EACA,gBE9FS;EF+FT,gBAAA;AAkBF;;AAfA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cCvGS;EDwGT,cAAA;AAkBF;;AAfA;;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBExHc;EFyHd,eAAA;EACA,gBAAA;EACA,WC/GM;EDgHN,YAAA;EACA,eAAA;AAkBF;AAhBE;;EACE,YAAA;AAmBJ;;AAfA;EACE,eAAA;EACA,uBAAA;EACA,kBAAA;AAkBF","sourcesContent":["@import '@common/scss/_variables';\n@import '@common/scss/_colors';\n\n// ─── Status colours ───────────────────────────────────────────────────────────\n\n// Fallback for any value the calendar payload returns that we don't recognise.\n// Bright magenta makes accidental drift obvious instead of silently grey.\n.yearDay,\n.monthDay {\n  background: #ff00aa;\n}\n\n.day_processed        { background: $accent; }\n.day_processing       { background: #3b7fd4; }\n.day_pending          { background: #00bcd4; }\n.day_waiting_archive  { background: #64b5f6; }\n.day_duplicate        { background: #8e6acb; }\n.day_upload_failed    { background: #efa12c; }\n.day_failed           { background: $error; }\n.day_no_data          { background: #7a7a7a; }\n.day_empty            { background: $grey-200; }\n\n// ─── Yearly view ─────────────────────────────────────────────────────────────\n\n.yearGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: $margin-l;\n  margin-top: $margin-m;\n\n  @media (max-width: 900px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  @media (max-width: 600px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.yearMonth {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.yearMonthLabel {\n  font-size: 11px;\n  font-weight: 600;\n  color: $grey-400;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.yearDayGrid {\n  display: grid;\n  grid-template-columns: repeat(7, 10px);\n  gap: 2px;\n}\n\n.yearDay,\n.yearEmptyCell {\n  display: block;\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  position: relative;\n\n  &:hover {\n    opacity: 0.75;\n  }\n}\n\n.yearDay:hover::after {\n  content: attr(data-tip);\n  position: absolute;\n  bottom: calc(100% + 4px);\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.85);\n  color: $white;\n  padding: 1px 6px;\n  border-radius: 3px;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 1.3;\n  white-space: nowrap;\n  pointer-events: none;\n  z-index: 10;\n}\n\n.yearEmptyCell {\n  cursor: default;\n  background: transparent;\n}\n\n// ─── Monthly view ─────────────────────────────────────────────────────────────\n\n.monthGrid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 4px;\n  margin-top: $margin-m;\n  max-width: 560px;\n}\n\n.monthWeekday {\n  text-align: center;\n  font-size: 11px;\n  font-weight: 600;\n  color: $grey-400;\n  padding: 4px 0;\n}\n\n.monthDay,\n.monthEmptyCell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  border-radius: $border-radius;\n  font-size: 12px;\n  font-weight: 500;\n  color: $white;\n  border: none;\n  cursor: pointer;\n\n  &:hover {\n    opacity: 0.8;\n  }\n}\n\n.monthEmptyCell {\n  cursor: default;\n  background: transparent;\n  color: transparent;\n}\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"yearDay": `SyncCalendar_yearDay__6fOU+`,
	"monthDay": `SyncCalendar_monthDay__mFDve`,
	"day_processed": `SyncCalendar_day_processed__B3iDQ`,
	"day_processing": `SyncCalendar_day_processing__z5y+7`,
	"day_pending": `SyncCalendar_day_pending__NYqPX`,
	"day_waiting_archive": `SyncCalendar_day_waiting_archive__-KRGa`,
	"day_duplicate": `SyncCalendar_day_duplicate__7sHQS`,
	"day_upload_failed": `SyncCalendar_day_upload_failed__644Bu`,
	"day_failed": `SyncCalendar_day_failed__M2BtJ`,
	"day_no_data": `SyncCalendar_day_no_data__DPw0l`,
	"day_empty": `SyncCalendar_day_empty__v6zMF`,
	"yearGrid": `SyncCalendar_yearGrid__YM8hL`,
	"yearMonth": `SyncCalendar_yearMonth__TN8pm`,
	"yearMonthLabel": `SyncCalendar_yearMonthLabel__kgx1p`,
	"yearDayGrid": `SyncCalendar_yearDayGrid__0Os87`,
	"yearEmptyCell": `SyncCalendar_yearEmptyCell__oVeXA`,
	"monthGrid": `SyncCalendar_monthGrid__OTVBC`,
	"monthWeekday": `SyncCalendar_monthWeekday__DYSFO`,
	"monthEmptyCell": `SyncCalendar_monthEmptyCell__fmApu`
};
export default ___CSS_LOADER_EXPORT___;
